<template>
    <div class="card-container">
        <div class="card-wrapper" :class="{ 'card-wrapper--list': displayType === 'list' }">
            <a
                :href="offer.detail_link"
                class="card h-100 text-decoration-none position-relative"
                :style="offer.car.status === 'reserved' ? 'opacity:0.5;' : ''"
                @click="handleCardClick">

                <!-- Card actions (outside card-image to avoid overflow:hidden clipping) -->
                <div v-if="displayType !== 'list'" class="card-actions">
                    <!-- Porovnání -->
                    <button @click.stop.prevent="toggleCompare" :class="['btn-icon', 'btn-icon--compare', { active: isCompared }]" :title="isCompared ? 'Zrušit porovnání' : 'Porovnat'">
                        <svg v-if="!isCompared" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.25 6.7124C1.83579 6.7124 1.5 7.04819 1.5 7.4624C1.5 7.87662 1.83579 8.2124 2.25 8.2124V6.7124ZM2.25 8.2124H21.75V6.7124H2.25V8.2124Z" fill="black"/>
                            <path d="M17.25 3.375L21.75 7.5L17.25 11.625" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                            <path d="M21.75 17.2876C22.1642 17.2876 22.5 16.9518 22.5 16.5376C22.5 16.1234 22.1642 15.7876 21.75 15.7876L21.75 17.2876ZM21.75 15.7876L2.25 15.7876L2.25 17.2876L21.75 17.2876L21.75 15.7876Z" fill="black"/>
                            <path d="M6.75 20.625L2.25 16.5L6.75 12.375" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                        <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.25 5.9624C1.42157 5.9624 0.75 6.63398 0.75 7.4624C0.75 8.29083 1.42157 8.9624 2.25 8.9624V5.9624ZM2.25 8.9624H21.75V5.9624H2.25V8.9624Z" fill="black"/>
                            <path d="M17.25 3.375L21.75 7.5L17.25 11.625" stroke="black" stroke-width="3" stroke-linecap="round"/>
                            <path d="M21.75 18.0376C22.5784 18.0376 23.25 17.366 23.25 16.5376C23.25 15.7092 22.5784 15.0376 21.75 15.0376L21.75 18.0376ZM21.75 15.0376L2.25 15.0376L2.25 18.0376L21.75 18.0376L21.75 15.0376Z" fill="black"/>
                            <path d="M6.75 20.625L2.25 16.5L6.75 12.375" stroke="black" stroke-width="3" stroke-linecap="round"/>
                        </svg>
                    </button>

                    <!-- Oblíbené -->
                    <button @click.stop.prevent="toggleFavorite" :class="['btn-icon', 'btn-icon--like', { active: isFavorite }]" :title="isFavorite ? 'Odebrat z oblíbených' : 'Přidat do oblíbených'">
                        <svg v-if="!isFavorite" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 22L10.55 20.5613C5.4 15.4714 2 12.1144 2 7.99455C2 4.6376 4.42 2 7.5 2C9.24 2 10.91 2.88283 12 4.27793C13.09 2.88283 14.76 2 16.5 2C19.58 2 22 4.6376 22 7.99455C22 12.1144 18.6 15.4714 13.45 20.5722L12 22Z" stroke="black" stroke-width="1.5" stroke-linecap="square"/>
                        </svg>
                        <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 22L10.55 20.5613C5.4 15.4714 2 12.1144 2 7.99455C2 4.6376 4.42 2 7.5 2C9.24 2 10.91 2.88283 12 4.27793C13.09 2.88283 14.76 2 16.5 2C19.58 2 22 4.6376 22 7.99455C22 12.1144 18.6 15.4714 13.45 20.5722L12 22Z" fill="black" stroke="black" stroke-width="1.5" stroke-linecap="square"/>
                        </svg>
                    </button>
                </div>

                <!-- Carousel -->
                <div class="card-image mb-2">

                    <div class="card-status-bar">
                        <span
                            v-for="(b, i) in badges"
                            :key="i"
                            class="badge"
                            :class="[b.class, { 'volvo-selekt-tooltip-trigger': b.class === 'badge--select' }]"
                            @click.stop.prevent="b.class === 'badge--select' ? showVolvoSelectTooltip($event) : null"
                        >
                            <span class="text-uppercase badge-text">{{ b.text }}</span>
                            <!-- Add tooltip for Volvo Select badge -->
                            <template v-if="b.class === 'badge--select'">
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="ms-1 bi bi-info-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
                                </svg>
                                <div class="volvo-selekt-tooltip-content" v-html="volvoSelektTooltip"></div>
                            </template>
                        </span>
                        <span v-if="offer.car.custom_tag" :key="offer.car.id + '-custom-tag'" class="badge badge--custom">
                            <span class="text-uppercase badge-text">{{ offer.car.custom_tag }}</span>
                        </span>
                        <!-- Add custom tags from car.tags where type is custom -->
                        <span
                            v-for="tag in customTags"
                            :key="tag.key"
                            class="badge"
                            :class="tag.classes"
                            :style="tag.style"
                        >
                            <span class="text-uppercase badge-text">{{ tag.title }}</span>
                        </span>
                    </div>

                    <!-- Single image display when there's only one image -->
                    <div v-if="images.length === 1" class="single-image-container">
                        <img
                            :src="images[0].box_path"
                            class="card-img-top single-image"
                            loading="lazy"
                            :alt="offer.car.name"
                        />
                    </div>

                    <!-- Carousel for multiple images -->
                    <div
                        v-else-if="images.length > 1"
                        class="carousel-container"
                        @touchstart="handleTouchStart"
                        @touchmove="handleTouchMove"
                        @touchend="handleTouchEnd"
                        @mousedown="handleMouseDown"
                        @mousemove="handleMouseMove"
                        @mouseup="handleMouseUp"
                        @mouseleave="handleMouseLeave"
                    >
                        <div
                            class="carousel-images-wrapper"
                            :style="{
                                transform: `translateX(${dragOffset}px)`,
                                transition: isDragging ? 'none' : 'transform 0.3s ease',
                                willChange: 'transform' /* Optimize for animations */
                            }"
                        >
                            <!-- Previous image -->
                            <img
                                :src="images[getPrevIndex()].box_path"
                                class="card-img-top carousel-image prev-image"
                                loading="lazy"
                                :alt="`${offer.car.name} - ${getPrevIndex()+1}`"
                            />

                            <!-- Current image -->
                            <img
                                :src="images[currentIndex].box_path"
                                class="card-img-top carousel-image current-image"
                                loading="lazy"
                                :alt="`${offer.car.name} - ${currentIndex+1}`"
                            />

                            <!-- Next image -->
                            <img
                                :src="images[getNextIndex()].box_path"
                                class="card-img-top carousel-image next-image"
                                loading="lazy"
                                :alt="`${offer.car.name} - ${getNextIndex()+1}`"
                            />
                        </div>

                        <!-- Carousel navigation buttons -->
                        <button v-if="displayType !== 'list'" class="carousel__btn prev" @click.stop.prevent="prev"></button>
                        <button v-if="displayType !== 'list'" class="carousel__btn next" @click.stop.prevent="next"></button>

                        <!-- Carousel indicators -->
                        <div class="carousel__indicators">
                            <span
                                v-for="(image, index) in images"
                                :key="index"
                                class="carousel__indicator"
                                :class="{ 'active': index === currentIndex }"
                                @click.stop.prevent="currentIndex = index"
                            ></span>
                        </div>
                    </div>

                    <!-- Placeholder when no images -->
                    <img
                        v-else
                        :src="noImageUrl"
                        :alt="noImagesText"
                        class="card-img-top placeholder"
                        loading="lazy"
                    />
                </div>



                <!-- wrapper pro „více" + menu -->
                <div v-if="displayType !== 'list'" class="more-wrapper">
                    <button class="btn-icon--more" @click.stop.prevent="$emit('toggle-dropdown', offer.id)">
                        <!-- tři tečky SVG -->
                        <svg width="24" height="24" viewBox="0 0 24 24">
                            <circle cx="5"  cy="12" r="2"/>
                            <circle cx="12" cy="12" r="2"/>
                            <circle cx="19" cy="12" r="2"/>
                        </svg>
                    </button>

                    <ul v-if="isDropdownOpen" class="card-actions-dropdown-menu">
                        <li class="my-1">
                            <button @click.stop.prevent="toggleFavorite" class="dropdown-item">
                                <div class="d-flex align-items-center">
                                    <template v-if="!isFavorite">
                                        <svg class="icon me-3" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 22L10.55 20.5613C5.4 15.4714 2 12.1144 2 7.99455C2 4.6376 4.42 2 7.5 2C9.24 2 10.91 2.88283 12 4.27793C13.09 2.88283 14.76 2 16.5 2C19.58 2 22 4.6376 22 7.99455C22 12.1144 18.6 15.4714 13.45 20.5722L12 22Z" stroke="white" stroke-width="1.5" stroke-linecap="square"/></svg>
                                        <svg class="icon-fill me-3" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 22L10.55 20.5613C5.4 15.4714 2 12.1144 2 7.99455C2 4.6376 4.42 2 7.5 2C9.24 2 10.91 2.88283 12 4.27793C13.09 2.88283 14.76 2 16.5 2C19.58 2 22 4.6376 22 7.99455C22 12.1144 18.6 15.4714 13.45 20.5722L12 22Z" fill="white" stroke="white" stroke-width="1.5" stroke-linecap="square"/></svg>
                                    </template>
                                    <template v-else>
                                        <svg class="icon me-3" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 22L10.55 20.5613C5.4 15.4714 2 12.1144 2 7.99455C2 4.6376 4.42 2 7.5 2C9.24 2 10.91 2.88283 12 4.27793C13.09 2.88283 14.76 2 16.5 2C19.58 2 22 4.6376 22 7.99455C22 12.1144 18.6 15.4714 13.45 20.5722L12 22Z" fill="#1ef1c6" stroke="#1ef1c6" stroke-width="1.5" stroke-linecap="square"/></svg>
                                        <svg class="icon-fill me-3" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 22L10.55 20.5613C5.4 15.4714 2 12.1144 2 7.99455C2 4.6376 4.42 2 7.5 2C9.24 2 10.91 2.88283 12 4.27793C13.09 2.88283 14.76 2 16.5 2C19.58 2 22 4.6376 22 7.99455C22 12.1144 18.6 15.4714 13.45 20.5722L12 22Z" fill="#1ef1c6" stroke="#1ef1c6" stroke-width="1.5" stroke-linecap="square"/></svg>
                                    </template>
                                    {{ isFavorite ? lblDropdownRemoveFromFavorites : lblDropdownAddToFavorites }}
                                </div>
                            </button>
                        </li>
                        <li class="my-1">
                            <button @click.stop.prevent="toggleCompare" class="dropdown-item">
                                <div class="d-flex align-items-center">
                                    <template v-if="!isCompared">
                                        <svg class="me-3 icon icon--w24" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M2.25 6.7124C1.83579 6.7124 1.5 7.04819 1.5 7.4624C1.5 7.87662 1.83579 8.2124 2.25 8.2124V6.7124ZM2.25 8.2124H21.75V6.7124H2.25V8.2124Z" fill="white"/>
                                            <path d="M17.25 3.375L21.75 7.5L17.25 11.625" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                            <path d="M21.75 17.2876C22.1642 17.2876 22.5 16.9518 22.5 16.5376C22.5 16.1234 22.1642 15.7876 21.75 15.7876L21.75 17.2876ZM21.75 15.7876L2.25 15.7876L2.25 17.2876L21.75 17.2876L21.75 15.7876Z" fill="white"/>
                                            <path d="M6.75 20.625L2.25 16.5L6.75 12.375" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                        </svg>
                                        <svg class="me-3 icon-fill icon--w24" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M2.25 5.9624C1.42157 5.9624 0.75 6.63398 0.75 7.4624C0.75 8.29083 1.42157 8.9624 2.25 8.9624V5.9624ZM2.25 8.9624H21.75V5.9624H2.25V8.9624Z" fill="white"/>
                                            <path d="M17.25 3.375L21.75 7.5L17.25 11.625" stroke="white" stroke-width="3" stroke-linecap="round"/>
                                            <path d="M21.75 18.0376C22.5784 18.0376 23.25 17.366 23.25 16.5376C23.25 15.7092 22.5784 15.0376 21.75 15.0376L21.75 18.0376ZM21.75 15.0376L2.25 15.0376L2.25 18.0376L21.75 18.0376L21.75 15.0376Z" fill="white"/>
                                            <path d="M6.75 20.625L2.25 16.5L6.75 12.375" stroke="white" stroke-width="3" stroke-linecap="round"/>
                                        </svg>
                                    </template>
                                    <template v-else>
                                        <svg class="me-3 icon icon--w24" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M2.25 5.9624C1.42157 5.9624 0.75 6.63398 0.75 7.4624C0.75 8.29083 1.42157 8.9624 2.25 8.9624V5.9624ZM2.25 8.9624H21.75V5.9624H2.25V8.9624Z" fill="#1ef1c6"/>
                                            <path d="M17.25 3.375L21.75 7.5L17.25 11.625" stroke="#1ef1c6" stroke-width="3" stroke-linecap="round"/>
                                            <path d="M21.75 18.0376C22.5784 18.0376 23.25 17.366 23.25 16.5376C23.25 15.7092 22.5784 15.0376 21.75 15.0376L21.75 18.0376ZM21.75 15.0376L2.25 15.0376L2.25 18.0376L21.75 18.0376L21.75 15.0376Z" fill="#1ef1c6"/>
                                            <path d="M6.75 20.625L2.25 16.5L6.75 12.375" stroke="#1ef1c6" stroke-width="3" stroke-linecap="round"/>
                                        </svg>
                                        <svg class="me-3 icon-fill icon--w24" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M2.25 5.9624C1.42157 5.9624 0.75 6.63398 0.75 7.4624C0.75 8.29083 1.42157 8.9624 2.25 8.9624V5.9624ZM2.25 8.9624H21.75V5.9624H2.25V8.9624Z" fill="#1ef1c6"/>
                                            <path d="M17.25 3.375L21.75 7.5L17.25 11.625" stroke="#1ef1c6" stroke-width="3" stroke-linecap="round"/>
                                            <path d="M21.75 18.0376C22.5784 18.0376 23.25 17.366 23.25 16.5376C23.25 15.7092 22.5784 15.0376 21.75 15.0376L21.75 18.0376ZM21.75 15.0376L2.25 15.0376L2.25 18.0376L21.75 18.0376L21.75 15.0376Z" fill="#1ef1c6"/>
                                            <path d="M6.75 20.625L2.25 16.5L6.75 12.375" stroke="#1ef1c6" stroke-width="3" stroke-linecap="round"/>
                                        </svg>
                                    </template>
                                    {{ isCompared ? lblDropdownRemoveFromComparison : lblDropdownAddToComparison }}
                                </div>
                            </button>
                        </li>
                        <li class="my-1">
                            <button @click.stop.prevent="copyLink" class="dropdown-item">
                                <div class="d-flex align-items-center">
                                    <svg class="icon me-3" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.625 18.375V18.375C2.625 13.4044 6.65444 9.375 11.625 9.375H21.375" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                        <path d="M18 6L21.375 9.375L18 12.75" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                    </svg>
                                    <svg class="icon-fill me-3" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.625 18.375V18.375C2.625 13.4044 6.65444 9.375 11.625 9.375H21.375" stroke="white" stroke-width="3" stroke-linecap="round"/>
                                        <path d="M18 6L21.375 9.375L18 12.75" stroke="white" stroke-width="3" stroke-linecap="round"/>
                                    </svg>
                                    {{ lblShare }}
                                </div>
                            </button>
                        </li>
                        <li class="my-1">
                            <button @click.stop.prevent="goToDetails" class="dropdown-item">
                                <div class="d-flex align-items-center">
                                    <svg class="icon icon--detail me-3" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6 19V19.525C6 19.9417 5.85833 20.2917 5.575 20.575C5.29167 20.8583 4.93333 21 4.5 21C4.08333 21 3.72933 20.854 3.438 20.562C3.146 20.2707 3 19.9167 3 19.5V12L5.1 6C5.2 5.7 5.37933 5.45833 5.638 5.275C5.896 5.09167 6.18333 5 6.5 5H17.5C17.8167 5 18.1043 5.09167 18.363 5.275C18.621 5.45833 18.8 5.7 18.9 6L21 12V19.525C21 19.9417 20.8583 20.2917 20.575 20.575C20.2917 20.8583 19.9333 21 19.5 21C19.0833 21 18.7293 20.854 18.438 20.562C18.146 20.2707 18 19.9167 18 19.5V19H6ZM5.8 10H18.2L17.15 7H6.85L5.8 10ZM7.5 16C7.91667 16 8.27067 15.854 8.562 15.562C8.854 15.2707 9 14.9167 9 14.5C9 14.0833 8.854 13.7293 8.562 13.438C8.27067 13.146 7.91667 13 7.5 13C7.08333 13 6.72933 13.146 6.438 13.438C6.146 13.7293 6 14.0833 6 14.5C6 14.9167 6.146 15.2707 6.438 15.562C6.72933 15.854 7.08333 16 7.5 16ZM16.5 16C16.9167 16 17.2707 15.854 17.562 15.562C17.854 15.2707 18 14.9167 18 14.5C18 14.0833 17.854 13.7293 17.562 13.438C17.2707 13.146 16.9167 13 16.5 13C16.0833 13 15.7293 13.146 15.438 13.438C15.146 13.7293 15 14.0833 15 14.5C15 14.9167 15.146 15.2707 15.438 15.562C15.7293 15.854 16.0833 16 16.5 16ZM5 17H19V12H5V17Z" fill="white"/>
                                    </svg>
                                    <svg class="icon-fill icon--detail me-3" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                         <path d="M6 19V19.525C6 19.9417 5.85833 20.2917 5.575 20.575C5.29167 20.8583 4.93333 21 4.5 21C4.08333 21 3.72933 20.854 3.438 20.562C3.146 20.2707 3 19.9167 3 19.5V12L5.1 6C5.2 5.7 5.37933 5.45833 5.638 5.275C5.896 5.09167 6.18333 5 6.5 5H17.5C17.8167 5 18.1043 5.09167 18.363 5.275C18.621 5.45833 18.8 5.7 18.9 6L21 12V19.525C21 19.9417 20.8583 20.2917 20.575 20.575C20.2917 20.8583 19.9333 21 19.5 21C19.0833 21 18.7293 20.854 18.438 20.562C18.146 20.2707 18 19.9167 18 19.5V19H6ZM5.8 10H18.2L17.15 7H6.85L5.8 10ZM7.5 16C7.91667 16 8.27067 15.854 8.562 15.562C8.854 15.2707 9 14.9167 9 14.5C9 14.0833 8.854 13.7293 8.562 13.438C8.27067 13.146 7.91667 13 7.5 13C7.08333 13 6.72933 13.146 6.438 13.438C6.146 13.7293 6 14.0833 6 14.5C6 14.9167 6.146 15.2707 6.438 15.562C6.72933 15.854 7.08333 16 7.5 16ZM16.5 16C16.9167 16 17.2707 15.854 17.562 15.562C17.854 15.2707 18 14.9167 18 14.5C18 14.0833 17.854 13.7293 17.562 13.438C17.2707 13.146 16.9167 13 16.5 13C16.0833 13 15.7293 13.146 15.438 13.438C15.146 13.7293 15 14.0833 15 14.5C15 14.9167 15.146 15.2707 15.438 15.562C15.7293 15.854 16.0833 16 16.5 16Z" fill="white"/>
                                    </svg>
                                    {{ lblDetails }}
                                </div>
                            </button>
                        </li>
                    </ul>
                </div>

                <!-- Body -->
                <div class="card-body">
                    <!-- Grid view layout -->
                    <template v-if="displayType !== 'list'">
                        <!-- Vehicle name -->
                        <h2 class="card-title h5 ellipsis-1 mb-2"
                            :title="offer.car.year_of_manufacture + ' ' + offer.car.name">
                            <span class="detail--title--brand me-1" v-if="offer.car.car_brand">{{ offer.car.car_brand.name }}</span>
                            <span class="detail--title--model me-1" v-if="offer.car.car_model">{{ offer.car.car_model.name }}</span>
                            <span class="detail--title--variant">{{ offer.car.imported_name }}</span>
                        </h2>
                        <!-- Vehicle parameters -->
                        <div class="labels d-flex flex-nowrap gap-1 mt-auto overflow-hidden mb-2">
                            <span v-if="formattedMileage" class="label">{{ formattedMileage }}</span>
                            <span v-if="offer.car.year_of_manufacture" class="label">{{ offer.car.year_of_manufacture }}</span>
                            <span v-if="offer.car.engine_power_kw" class="label">{{ offer.car.engine_power_kw }} kW</span>
                            <span v-if="offer.car.fuel_type" class="label">{{ offer.car.fuel_type.name }}</span>
                            <span v-if="offer.car.transmission_type" class="label" :title="offer.car.transmission_type.name">{{ offer.car.transmission_type.name }}</span>
                        </div>
                    </template>

                    <!-- List view layout -->
                    <template v-else>
                        <!-- Vehicle name -->
                        <h2 class="card-title h5 ellipsis-1 mb-8px"
                            :title="offer.car.year_of_manufacture + ' ' + offer.car.name">
                            <span class="detail--title--brand pe-1 text-white" v-if="offer.car.car_brand">{{ offer.car.car_brand.name }}</span>
                            <span class="detail--title--model pe-1 text--grey-200" v-if="offer.car.car_model">{{ offer.car.car_model.name }}</span>
                            <span class="detail--title--variant text--400">{{ offer.car.imported_name }}</span>
                        </h2>
                        <!-- Vehicle parameters -->
                        <div class="labels d-flex flex-nowrap gap-1 mt-auto mb-12px">
                            <span v-if="formattedMileage" class="label text--13px text--500 text-nowrap">{{ formattedMileage }}</span>
                            <span v-if="offer.car.year_of_manufacture" class="label text--13px text--500 text-nowrap">{{ offer.car.year_of_manufacture }}</span>
                            <span v-if="offer.car.engine_power_kw" class="label text--13px">{{ offer.car.engine_power_kw }} kW</span>
                            <span v-if="offer.car.fuel_type" class="label text--13px">{{ offer.car.fuel_type.name }}</span>
                            <span v-if="offer.car.transmission_type" class="label text--13px label--ellipsis me-0" :title="offer.car.transmission_type.name">{{ offer.car.transmission_type.name }}</span>
                        </div>
                    </template>

                    <!-- Price section -->
                    <div class="text--600 text--grey-dark text-nowrap">

                        <!-- loans only (no leasing) - show monthly incl. VAT if available -->
                        <template v-if="offer.availability_type.id === 4 && monthlyInclVat && offer.has_loans && !offer.has_leasings">
                            <div class="card__priceContainer d-flex align-items-end">
                                <span class="card__priceContainer-price text-white text-nowrap h4 d-inline mb-0 me-1">
                                    {{ lblFrom }}
                                </span>
                                <span :class="displayType === 'list' ? 'h3 d-inline mb-0' : 'h4 d-inline mb-0'">
                                    {{ monthlyInclVat }}
                                </span>
                                <span class="card__priceContainer-price-2 text--semi-small text--grey ms-2 text--400">
                                    {{ lblMonthlyInclVat }}
                                </span>
                            </div>
                        </template>
                        <!-- leasing -->
                        <template v-else-if="offer.availability_type.id === 4">
                            <div class="card__priceContainer d-flex align-items-end">
                                <span class="card__priceContainer-price text-white text-nowrap h4 d-inline mb-0 me-1">
                                    {{ lblFrom }}
                                </span>
                                <span :class="displayType === 'list' ? 'h3 d-inline mb-0' : 'h4 d-inline mb-0'">
                                    {{ monthlyInclVat }}
                                </span>
                                <span class="card__priceContainer-price-2 text--semi-small text--grey ms-2 text--400">
                                    {{ lblMonthlyExclVat }}
                                </span>
                            </div>
                            <!--                            <div v-if="monthlyInclVat" class="card__priceContainer d-flex align-items-end ps-5px">-->
                            <!--                                <small class="text&#45;&#45;350 text&#45;&#45;grey">-->
                            <!--                                    {{ monthlyInclVat }} {{ lblMonthlyInclVat }}-->
                            <!--                                </small>-->
                            <!--                            </div>-->
                        </template>

                        <!-- všechny ostatní -->
                        <template v-else>
                            <div class="card__priceContainer d-flex align-items-end ps-5px">
                                <span :class="displayType === 'list' ? 'text--28px text--300 text-white' : 'card__priceContainer-price text-white text-nowrap h4 d-inline mb-0'">
                                    {{ priceInclVat }}
                                </span>
                                <span v-if="priceExclVat" :class="displayType === 'list' ? 'ms-2 text--normal-size text--350 text--grey-200' : 'card__priceContainer-price-2 ms-2 text--350 text--grey-200 text-nowrap'">
                                    {{ priceExclVat }} {{ lblExclVatSimple }}
                                </span>
                            </div>
                        </template>
                    </div>

                    <!-- Buttons for list view -->
                    <div v-if="displayType === 'list'" class="d-flex align-items-center justify-content-between mt-3 mb-2">
                        <div class="d-flex align-items-center">
                            <!-- Save/Favorite button -->
                            <button @click.stop.prevent="toggleFavorite"
                                    class="text-nowrap btn btn-sm btn-outline-light text--500 me-2"
                                    :class="{ active: isFavorite }">
                                <span>{{ isFavorite ? lblRemoveFromFavorites : lblAddToFavorites }}</span>
                                <svg v-if="!isFavorite" class="icon icon--like" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 22L10.55 20.5613C5.4 15.4714 2 12.1144 2 7.99455C2 4.6376 4.42 2 7.5 2C9.24 2 10.91 2.88283 12 4.27793C13.09 2.88283 14.76 2 16.5 2C19.58 2 22 4.6376 22 7.99455C22 12.1144 18.6 15.4714 13.45 20.5722L12 22Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"/>
                                </svg>
                                <svg v-else class="icon icon--like" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 22L10.55 20.5613C5.4 15.4714 2 12.1144 2 7.99455C2 4.6376 4.42 2 7.5 2C9.24 2 10.91 2.88283 12 4.27793C13.09 2.88283 14.76 2 16.5 2C19.58 2 22 4.6376 22 7.99455C22 12.1144 18.6 15.4714 13.45 20.5722L12 22Z" fill="#1ef1c6" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"/>
                                </svg>
                            </button>

                            <!-- Compare button -->
                            <button @click.stop.prevent="toggleCompare"
                                    class="text-nowrap btn btn-sm btn-outline-light text--500 me-2"
                                    :class="{ active: isCompared }">
                                <span>{{ isCompared ? lblRemoveFromComparison : lblAddToComparison }}</span>
                                <svg v-if="!isCompared" class="ms-2" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.25 6.7124C1.83579 6.7124 1.5 7.04819 1.5 7.4624C1.5 7.87662 1.83579 8.2124 2.25 8.2124V6.7124ZM2.25 8.2124H21.75V6.7124H2.25V8.2124Z" fill="currentColor"/>
                                    <path d="M17.25 3.375L21.75 7.5L17.25 11.625" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                                    <path d="M21.75 17.2876C22.1642 17.2876 22.5 16.9518 22.5 16.5376C22.5 16.1234 22.1642 15.7876 21.75 15.7876L21.75 17.2876ZM21.75 15.7876L2.25 15.7876L2.25 17.2876L21.75 17.2876L21.75 15.7876Z" fill="currentColor"/>
                                    <path d="M6.75 20.625L2.25 16.5L6.75 12.375" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                                </svg>
                                <svg v-else class="ms-2" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.25 5.9624C1.42157 5.9624 0.75 6.63398 0.75 7.4624C0.75 8.29083 1.42157 8.9624 2.25 8.9624V5.9624ZM2.25 8.9624H21.75V5.9624H2.25V8.9624Z" fill="currentColor"/>
                                    <path d="M17.25 3.375L21.75 7.5L17.25 11.625" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
                                    <path d="M21.75 18.0376C22.5784 18.0376 23.25 17.366 23.25 16.5376C23.25 15.7092 22.5784 15.0376 21.75 15.0376L21.75 18.0376ZM21.75 15.0376L2.25 15.0376L2.25 18.0376L21.75 18.0376L21.75 15.0376Z" fill="currentColor"/>
                                    <path d="M6.75 20.625L2.25 16.5L6.75 12.375" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
                                </svg>
                            </button>

                            <!-- Share button -->
                            <button @click.stop.prevent="copyLink" class="text-nowrap btn btn-sm btn-outline-light text--500">
                                <span>{{ lblShare }}</span>
                                <svg class="ms-2" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.625 18.375V18.375C2.625 13.4044 6.65444 9.375 11.625 9.375H21.375" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                                    <path d="M18 6L21.375 9.375L18 12.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                                </svg>
                            </button>
                        </div>

                        <!-- Details button (right) -->
                        <button @click.stop.prevent="goToDetails" class="text-nowrap btn btn-sm btn-primary-outline text--500">
                            <span>{{ lblShow }}</span>
                            <svg class="ms-2" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </a>
        </div>
    </div>

    <!-- Volvo Selekt Modal (shown on mobile) -->
    <VolvoSelektModal
        :is-visible="isModalVisible"
        :tooltip-content="volvoSelektTooltip"
        :badge-text="badgeTranslations['volvo-select'] || 'Volvo Selekt'"
        @close="isModalVisible = false"
    />
</template>

<script setup>
import VolvoSelektModal from '@/components/CarFilter/VolvoSelektModal.vue'
import { useCarCard } from '@/composables/useCarCard'

const noImageUrl = '/images/lynkac/no-image.png'

// definice eventů, které komponenta vyvolá
const emit = defineEmits([
    'add-to-comparison',
    'remove-from-comparison',
    'add-to-favorites',
    'remove-from-favorites',
    'toggle-dropdown',
    'car-selected',
])

// props
const props = defineProps({
    offer: { type: Object,  required: true },
    isCompared: { type: Boolean, default: false },
    isFavorite: { type: Boolean, default: false },
    isDropdownOpen:  { type: Boolean, default: false },
    displayType: { type: String, default: 'grid' },

    lblFrom:                            String,
    lblMonthlyInclVat:                  String,
    lblMonthlyExclVat:                  String,
    lblExclVatSimple:                   String,

    lblAddToFavorites:                  String,
    lblRemoveFromFavorites:             String,
    lblAddToComparison:                 String,
    lblRemoveFromComparison:            String,
    lblDropdownAddToFavorites:          String,
    lblDropdownRemoveFromFavorites:     String,
    lblDropdownAddToComparison:         String,
    lblDropdownRemoveFromComparison:    String,
    lblAddedToFavorites:                String,
    lblRemovedFromFavorites:            String,
    lblAddedToComparison:               String,
    lblRemovedFromComparison:           String,
    lblComparedCarsLimitReached:        String,
    lblShare:                           String,
    lblDetails:                         String,
    lblShow:                            String,
    lblMoreActions:                     String,
    noImagesText:                       String,

    // Add prop for Volvo Selekt tooltip content
    volvoSelektTooltip:      { type: String, default: '' },

    // Badge translations
    badgeTranslations:       { type: Object, default: () => ({}) },

    // Currency code for price formatting (e.g. 'CZK', 'EUR')
    currencyCode:            { type: String, default: 'CZK' },
})

// Use the composable for shared logic
const {
    // State
    currentIndex,
    activeTooltip,
    isModalVisible,
    touchStartX,
    touchStartY,
    touchEndX,
    isDragging,
    dragOffset,

    // Computed
    images,
    badges,
    customTags,
    formattedMileage,
    priceInclVat,
    priceExclVat,
    monthlyInclVat,
    monthlyExclVat,

    // Methods
    next,
    prev,
    getPrevIndex,
    getNextIndex,
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd,
    handleMouseDown,
    handleMouseMove,
    handleMouseUp,
    handleMouseLeave,
    handleSwipe,
    toggleCompare,
    toggleFavorite,
    copyLink,
    fallbackCopyTextToClipboard,
    goToDetails,
    showVolvoSelectTooltip,
    handleDocumentClick,
} = useCarCard(props, emit)

function handleCardClick() {
    emit('car-selected', props.offer)
}
</script>

<style scoped>
.card-wrapper {
    position: relative;
    height: 100%;
}

.card-status-bar {
    position: absolute;
    top: 0.5rem;
    left: 0.5rem;
    display: flex;
    gap: 0.5rem;
    z-index: 10;
    flex-wrap: wrap;
    max-width: 270px;
}

.card-status-bar .badge {
    margin-right: 0;
}

.card-image {
    position: relative;
    width: 100%;
    height: 257px;
    overflow: hidden;
    border-radius: 12px 12px 0 0;
}

.card-image img {
    display: block;
    height: 100%;
    object-fit: cover;
}

.card-actions {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    display: flex;
    gap: 0.5rem;
    align-items: flex-start;
    z-index: 20;
}

.btn-icon {
    background: transparent;
    border: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s ease;
    padding: 0;
}
.btn-icon:hover {
    transform: rotate(8deg) scale(1.1);
}

.btn-icon--compare {
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 100px;
    background-color: #ffffff;
    transition: all 300ms cubic-bezier(0.77, 0, 0.175, 1);
    position: absolute;
    right: 44px;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-icon--compare.active {
    background-color: #1ef1c6;
}

.btn-icon--compare svg {
    transition: all 300ms cubic-bezier(0.77, 0, 0.175, 1);
}

.btn-icon--like {
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 100px;
    background-color: #ffffff;
    transition: all 300ms cubic-bezier(0.77, 0, 0.175, 1);
    position: absolute;
    right: 5px;
    top: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-icon--like.active {
    background-color: #1ef1c6;
}

.btn-icon--like svg {
    transition: all 300ms cubic-bezier(0.77, 0, 0.175, 1);
}

.card-body {
    padding: 0.5rem 1rem;
}

.carousel__btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255,255,255,0.8);
    border: 1px solid #ddd;
    border-radius: 4px;
    width: 32px;
    height: 32px;
    font-size: 1.25rem;
    line-height: 1;
    padding: 0;
  /* hide arrows by default */
  opacity: 0;
  pointer-events: none; /* prevent clicking when hidden */
  transition: opacity 0.4s ease;
}

/* show on hover */
.carousel-container:hover .carousel__btn {
  opacity: 1;
  pointer-events: auto;
}

.carousel__btn.prev,
.carousel__btn.next {
  background: none;
  border: none;
  width: 40px;
  height: 40px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  padding: 0;
  cursor: pointer;
}

.carousel__btn.prev {
  left: 8px;
  background-image: url('/images/icons/ico-chevron-left-white-shadow.svg');
}

.carousel__btn.next {
  right: 8px;
  background-image: url('/images/icons/ico-chevron-right-white-shadow.svg');
}

.carousel__btn.prev,
.carousel__btn.next {
  background-repeat: no-repeat;
  background-position: 100%;
  background-size: contain;
}

.single-image-container {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
}

.single-image {
    /* width: 100%; */
    width: 101%; /* Fix for slight overflow issue */
    height: 100%;
    object-fit: cover;
    display: block;
    border-bottom: 1px solid #E7E9EE;
}

.carousel-container {
    /* width: 100%; */
    width: 101%; /* Fix for slight overflow issue */
    height: 100%;
    touch-action: pan-y; /* Allow vertical scrolling but handle horizontal swipes ourselves */
    cursor: grab;
    overflow: hidden; /* Ensure content doesn't overflow during drag */
    position: relative;
  border-bottom: 1px solid #E7E9EE;
}

.carousel-container:active {
    cursor: grabbing;
}

.carousel-images-wrapper {
    display: flex;
    width: 300%; /* Increased to allow full visibility of each image */
    height: 100%;
    position: relative;
    left: -100%; /* Adjusted to center the current image */
}

.carousel-image {
    flex: 1;
    width: 33.333%; /* Each image takes up 1/3 of the wrapper */
    object-fit: cover;
    display: block;
}

.carousel__indicators {
    position: absolute;
    bottom: 5px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    gap: 2px;
    z-index: 10;
}

.carousel__indicator {
    width: 14px;
    height: 14px;
    border: solid 1px #ffffff;
    border-radius: 50%;
    background-color: #9B989A;
    cursor: pointer;
    transition: background-color 0.3s ease;
    scale: 0.5;
}

.carousel__indicator.active {
    background-color: #1ef1c6;
}

.card-actions-dropdown-menu {
    position: absolute;
    top: 100%;
    right: 0;
    background: #1a1a1a;
    border: 1px solid #ddd;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    padding: 0.25rem 0;
    list-style: none;
    z-index: 30;
}

.card-actions-dropdown-menu button {
    display: block;
    width: 100%;
    min-width: 240px;
    padding: 0.5rem 1rem;
    text-align: left;
    background: none;
    border: none;
    cursor: pointer;
    color: #fff;
}

.card-actions-dropdown-menu button:hover {
    font-weight: bold;
}

/* Hide/show icons on hover */
.card-actions-dropdown-menu button .icon {
    display: inline-block;
}

.card-actions-dropdown-menu button .icon-fill {
    display: none;
}

.card-actions-dropdown-menu button:hover .icon {
    display: none;
}

.card-actions-dropdown-menu button:hover .icon-fill {
    display: inline-block;
}

/* List view styles */
.card-wrapper--list {
    height: 196px;
}
.card-wrapper--list .card {
    display: flex;
    flex-direction: row;
}

.card-wrapper--list .card-image {
    width: 300px;
    height: 196px;
    flex-shrink: 0;
    border-radius: 8px 0 0 8px;
    margin-bottom: 0;
}

.card-wrapper--list .card-image img {
    border-radius: 8px 0 0 8px;
}

.card-wrapper--list .card-body {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start; /* Changed from center to flex-start */
    padding: 1rem 1.5rem;
    min-width: 0; /* Fix for text overflow */
}

.card-wrapper--list .text-nowrap {
    text-wrap: wrap;
    white-space: normal;
}

.card-wrapper--list .more-wrapper {
    top: 0.5rem;
    right: 0.5rem;
}

.card-wrapper--list .labels {
    margin-bottom: 1rem;
}

.card-wrapper--list .card-title {
    line-height: 1;
    font-size: 25px;
    margin-bottom: 0.75rem;
}

.card-wrapper--list .card-body .ellipsis-1 {
    overflow: inherit;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* Button styles for list view */
.btn-circle {
    border: 1px solid #e7e9ee;
    bottom: 20px;
    position: absolute;
    right: 24px;
    border-radius: 50%;
    height: 40px;
    justify-content: center;
    padding: 0;
    width: 40px;
}

.btn-circle:hover {
    background-color: #f5f5f5;
    border-color: #ccc;
}

.icon--arrow {
    width: 18px;
    height: 15px;
}

.icon--share {
    width: 16px;
    height: 16px;
}

.icon--compare {
    width: 24px;
    height: 20px;
}

.icon--like {
    width: 20px;
    height: 20px;
}

.btn-sm {
    width: auto;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100px;
    font-size: 14px;
    font-weight: 600;
    padding: 0 16px;
    transition: color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease;
}

.btn-sm span {
    transition: color 0.2s ease;
}

.btn-sm svg {
    margin-left: 8px;
    transition: transform 0.2s ease;
}

.btn-sm:hover svg {
    transform: translateX(3px);
}

.btn-outline-primary {
    color: #255592;
    border-color: #255592;
}

.btn-outline-primary:hover, .btn-outline-primary.active {
    color: #fff;
    background-color: #255592;
    border-color: #255592;
}

.btn-outline-primary.active svg path {
    fill: #FACC16;
    stroke: #255592;
}

.btn-outline-primary:hover svg path {
    stroke: #fff;
}

.btn-primary-outline {
    color: #1ef1c6;
    border-color: #1ef1c6;
    background-color: transparent;
}

.btn-primary-outline:hover {
    color: #1c1c1c;
    background-color: #1ef1c6;
    border-color: #1ef1c6;
}

@media (max-width: 768px) {
    .card-wrapper--list .card {
        flex-direction: column;
    }

    .card-wrapper--list .card-image {
        width: 100%;
        border-radius: 8px 8px 0 0;
        height: 240px;
    }

    .card-wrapper--list .more-wrapper {
        top: 180px;
    }
}

/* Volvo Select tooltip styles */
.volvo-selekt-tooltip-content {
    display: none;
    position: absolute;
    top: 30px;
    left: -80px;
    white-space: normal;
}

.volvo-selekt-tooltip-content::after {
    content: '';
    position: absolute;
    top: -20px;
    left: 95px;
}

.more-wrapper {
  position: absolute;
  top: 235px;
  right: 0.5rem;
  z-index: 30;
  overflow: visible;        /* dropdown nesmí ořezávat rodič */
}

.btn-icon--more {
  background: #393939;
  border: 1px solid #393939;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background .2s, border-color .2s;
  padding: 0;
}

.btn-icon--more:hover {
  background: #393939;
  //border-color: #ccc;
}

.btn-icon--more .icon {
  margin-left: 0;
}

.btn-icon--more svg {
  width: 1.25rem;
  height: 1.25rem;
  stroke: #1ef1c6;
  fill: #1ef1c6;
}
</style>
